import { type FunctionComponent } from 'react';

import styled from 'styled-components';

import Loader from './components/Loader';

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Loading: FunctionComponent = () => (
    <Container>
        <Loader />
    </Container>
);

export default Loading;
